const SCRIPT_TARGET_PART_BY_SCENARIO_ID = {
    9: 1,
}

const SCRIPT_SCENARIO_IDS = [6, 7, 8, 9, 10, 14, 15]

function clone(value) {
    return JSON.parse(JSON.stringify(value))
}

export function getScriptTargetPartNumber(scenarioId) {
    return SCRIPT_TARGET_PART_BY_SCENARIO_ID[scenarioId] || 2
}

export function normalizeScriptMessageParts(messageParts) {
    if (!Array.isArray(messageParts)) {
        return []
    }

    return messageParts
        .map(part => ({
            partNumber: Number(part?.partNumber),
            variantNumber: Number(part?.variantNumber),
            textVariant: String(part?.textVariant || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n'),
        }))
        .filter(part => Number.isInteger(part.partNumber) && Number.isInteger(part.variantNumber))
        .sort((a, b) => a.partNumber - b.partNumber || a.variantNumber - b.variantNumber)
}

export function getScriptTextFromMessageParts(scenarioId, messageParts) {
    const targetPart = getScriptTargetPartNumber(scenarioId)
    return normalizeScriptMessageParts(messageParts).find(part => part.partNumber === targetPart)?.textVariant || ''
}

export function hasEmptyScriptMessagePart(messageParts) {
    return (
        !Array.isArray(messageParts) ||
        messageParts.length === 0 ||
        messageParts.some(part => String(part?.textVariant || '').trim() === '')
    )
}

function withScriptText(settings, scenarioId) {
    const messageParts = normalizeScriptMessageParts(settings.messageParts)
    return {
        ...settings,
        messageParts,
        scriptText: settings.scriptText || getScriptTextFromMessageParts(scenarioId, messageParts),
    }
}

function applyScriptTextToMessageParts(scenarioId, messageParts, scriptText) {
    if (!scriptText) {
        return messageParts
    }

    const targetPart = getScriptTargetPartNumber(scenarioId)
    const nextParts = messageParts.map(part => ({ ...part }))
    const targetParts = nextParts.filter(part => part.partNumber === targetPart)

    if (targetParts.length) {
        targetParts.forEach(part => {
            part.textVariant = scriptText
        })
    } else {
        nextParts.push({
            partNumber: targetPart,
            variantNumber: 1,
            textVariant: scriptText,
        })
    }

    return normalizeScriptMessageParts(nextParts)
}

function secondVisitInviteSettings() {
    return withScriptText(
        {
            visitsFrom: 1,
            visitsTo: 1,
            daysFrom: 25,
            daysTo: 30,
            messageParts: [
                { partNumber: 1, variantNumber: 1, textVariant: '{имя-клиента}, здравствуйте!' },
                { partNumber: 1, variantNumber: 2, textVariant: 'Здравствуйте, {имя-клиента}!' },
                { partNumber: 1, variantNumber: 3, textVariant: '{имя-клиента}, добрый день!' },
                {
                    partNumber: 2,
                    variantNumber: 1,
                    textVariant:
                        'Спасибо, что выбрали {название-салона}!\nХотим познакомить Вас со всеми нашими услугами.\n\nКстати, к следующему посещению мы дарим Вам {название-подарка}.\n\n',
                },
                {
                    partNumber: 3,
                    variantNumber: 1,
                    textVariant: 'Подскажите, планируете ли посетить нас в ближайшее время?',
                },
                {
                    partNumber: 3,
                    variantNumber: 2,
                    textVariant: 'Подскажите, планируете ли к нам в ближайшее время?',
                },
                {
                    partNumber: 3,
                    variantNumber: 3,
                    textVariant: 'Планируете ли Вы визит в ближайшее время?',
                },
            ],
        },
        6
    )
}

function hotClientsSettings() {
    return withScriptText(
        {
            messageParts: [
                {
                    partNumber: 1,
                    variantNumber: 1,
                    textVariant: '{имя-клиента}, добрый день! На связи Администратор {название-салона}',
                },
                {
                    partNumber: 1,
                    variantNumber: 2,
                    textVariant: 'Добрый день! На связи Администратор {название-салона}',
                },
                {
                    partNumber: 1,
                    variantNumber: 3,
                    textVariant: 'Здравствуйте! На связи Администратор {название-салона}',
                },
                {
                    partNumber: 2,
                    variantNumber: 1,
                    textVariant:
                        'С момента последнего визита прошло немного времени -\nхотим бережно напомнить: возможно, уже пора записаться.\n\nУточните, пожалуйста, удобно ли сейчас подобрать время и услугу?',
                },
                {
                    partNumber: 2,
                    variantNumber: 2,
                    textVariant: 'Напоминаем, что Ваш мастер уже ждет Вас.\n\nХотите подберем удобное время для визита?',
                },
            ],
        },
        7
    )
}

function newMasterReviewSettings() {
    return withScriptText(
        {
            messageParts: [
                { partNumber: 1, variantNumber: 1, textVariant: 'Добрый день!' },
                { partNumber: 1, variantNumber: 2, textVariant: 'Здравствуйте!' },
                {
                    partNumber: 2,
                    variantNumber: 1,
                    textVariant:
                        'Ваше последнее посещение было у нового для Вас мастера. Подскажите, все ли Вам понравилось? Есть ли замечания? Хотите ли Вы вернуть прежнего мастера?',
                },
                {
                    partNumber: 3,
                    variantNumber: 1,
                    textVariant: 'Отдел контроля и качества салона {название-салона}',
                },
            ],
        },
        8
    )
}

function forgottenClientsSettings() {
    return withScriptText(
        {
            daysFrom: 14,
            daysTo: 60,
            messageParts: [
                { partNumber: 1, variantNumber: 1, textVariant: '{имя-клиента}, здравствуйте!' },
                { partNumber: 1, variantNumber: 2, textVariant: 'Здравствуйте, {имя-клиента}!' },
                { partNumber: 1, variantNumber: 3, textVariant: '{имя-клиента}, добрый день!' },
                {
                    partNumber: 2,
                    variantNumber: 1,
                    textVariant:
                        'Возможно сейчас у Вас появилось время на нас.\nСегодня при записи действует скидка 10% на любую процедуру.',
                },
                { partNumber: 3, variantNumber: 1, textVariant: 'Актуально для Вас?' },
                {
                    partNumber: 3,
                    variantNumber: 2,
                    textVariant: 'Хотите подберу для Вас время и услугу?',
                },
                {
                    partNumber: 3,
                    variantNumber: 3,
                    textVariant: 'Удобно подобрать время для записи?',
                },
            ],
        },
        14
    )
}

function coolClientsSettings() {
    return withScriptText(
        {
            daysFrom: 61,
            daysTo: 120,
            messageParts: [
                {
                    partNumber: 1,
                    variantNumber: 1,
                    textVariant: '{имя-клиента}, добрый день! На связи Администратор {название-салона}',
                },
                {
                    partNumber: 1,
                    variantNumber: 2,
                    textVariant: 'Здравствуйте! На связи Администратор {название-салона}',
                },
                {
                    partNumber: 1,
                    variantNumber: 3,
                    textVariant: 'Добрый день! На связи Администратор {название-салона}',
                },
                {
                    partNumber: 2,
                    variantNumber: 1,
                    textVariant:
                        'Мы заметили, что Вас давно не было и хотим пригласить снова -\nв знак внимания дарим Вам подарок {название-подарка}.',
                },
                { partNumber: 3, variantNumber: 1, textVariant: 'Сейчас Вам актуален визит к нам?' },
                {
                    partNumber: 3,
                    variantNumber: 2,
                    textVariant: 'Хотите подберу для Вас удобное время для визита и услугу?',
                },
                { partNumber: 3, variantNumber: 3, textVariant: 'Актуально для Вас?' },
            ],
        },
        15
    )
}

function masterVacationSettings() {
    return withScriptText(
        {
            visitsFrom: 3,
            visitsTo: 1000,
            masterIds: [],
            messageParts: [
                { partNumber: 1, variantNumber: 1, textVariant: 'Добрый день, {имя-клиента}!' },
                { partNumber: 1, variantNumber: 2, textVariant: '{имя-клиента}, добрый день!' },
                { partNumber: 1, variantNumber: 3, textVariant: '{имя-клиента}, здравствуйте!' },
                {
                    partNumber: 2,
                    variantNumber: 1,
                    textVariant:
                        'Ваш специалист ИМЯ МАСТЕРА уходит в отпуск:\nс 99 месяц по 99 месяц.\n\nРекомендуем записаться заранее - места в последние дни перед отпуском разбирают быстро.',
                },
                {
                    partNumber: 3,
                    variantNumber: 1,
                    textVariant:
                        'Подобрать для Вас удобное время?\n\nЗаписаться самостоятельно:\n{ссылка-на-онлайн-запись}',
                },
                {
                    partNumber: 3,
                    variantNumber: 2,
                    textVariant:
                        'Вам актуально подобрать время для записи?\n\nЗаписаться самостоятельно:\n{ссылка-на-онлайн-запись}',
                },
            ],
        },
        9
    )
}

function cancelledClientsSettings() {
    return withScriptText(
        {
            messageParts: [
                { partNumber: 1, variantNumber: 1, textVariant: '{имя-клиента}, здравствуйте!' },
                { partNumber: 1, variantNumber: 2, textVariant: 'Здравствуйте, {имя-клиента}!' },
                { partNumber: 1, variantNumber: 3, textVariant: '{имя-клиента}, добрый день!' },
                {
                    partNumber: 2,
                    variantNumber: 1,
                    textVariant:
                        'Заметили, что Ваша запись в {название-салона} не состоялась.\nБудем рады видеть Вас снова - подберем удобное время.',
                },
                { partNumber: 3, variantNumber: 1, textVariant: 'Хотите подберу для Вас время и услугу?' },
                { partNumber: 3, variantNumber: 2, textVariant: 'Актуально для Вас?' },
            ],
        },
        10
    )
}

export function getScenarioDefaultSettings(scenarioId) {
    if (scenarioId === 1) {
        return { mode: 'test' }
    }
    if (scenarioId === 2) {
        return { contacts: [], sendToReportRecipients: false }
    }
    if (scenarioId === 5) {
        return { phones: [] }
    }
    if (scenarioId === 6) {
        return secondVisitInviteSettings()
    }
    if (scenarioId === 7) {
        return hotClientsSettings()
    }
    if (scenarioId === 8) {
        return newMasterReviewSettings()
    }
    if (scenarioId === 9) {
        return masterVacationSettings()
    }
    if (scenarioId === 10) {
        return cancelledClientsSettings()
    }
    if (scenarioId === 12) {
        return {
            enabled: true,
            scriptText:
                'Совсем скоро к вам придет клиент: {имя-клиента}\n\nОн записан на {дата-и-время} на услуги:\n{названия-услуг}\n\n🔄 {имя-клиента} посещает салон раз в {цикл-возврата}\n\n➕Несколько раз пробовал дополнительные услуги:\n{дополнительные-услуги}\n\n🛍{имя-клиента} уже покупал у нас:\n{товары}\n\nОбязательно предложите клиенту домашний уход и/или порекомендуйте дополнительные услуги во время записи.\n\nЛегкой работы и высоких чеков!',
            additionalServiceIds: ['svc_001', 'svc_003'],
        }
    }
    if (scenarioId === 14) {
        return forgottenClientsSettings()
    }
    if (scenarioId === 15) {
        return coolClientsSettings()
    }
    return {}
}

export function mergeWithDefaults(defaults, incoming) {
    const merged = { ...defaults, ...incoming }

    Object.keys(defaults).forEach(key => {
        const defaultValue = defaults[key]
        const incomingValue = incoming[key]

        if (incomingValue === undefined || incomingValue === null) {
            merged[key] = clone(defaultValue)
            return
        }

        if (typeof defaultValue === 'string' && String(incomingValue).trim() === '') {
            merged[key] = defaultValue
        }

        if (Array.isArray(defaultValue) && (!Array.isArray(incomingValue) || incomingValue.length === 0)) {
            merged[key] = clone(defaultValue)
        }
    })

    return merged
}

export function normalizeCommPhoneEntry(phoneItem) {
    if (typeof phoneItem === 'string') {
        return { phone: phoneItem, channelId: null, channelName: null }
    }
    return {
        phone: String(phoneItem?.phone || '').trim(),
        channelId: phoneItem?.channelId || null,
        channelName: phoneItem?.channelName || null,
    }
}

export function normalizeSettings(scenario) {
    const defaults = getScenarioDefaultSettings(scenario.scenarioId)
    const incoming = scenario.settings ? clone(scenario.settings) : {}
    const normalized = mergeWithDefaults(defaults, incoming)
    if (SCRIPT_SCENARIO_IDS.includes(scenario.scenarioId)) {
        normalized.messageParts = normalizeScriptMessageParts(normalized.messageParts)
        if (!incoming.messageParts && incoming.scriptText) {
            normalized.messageParts = applyScriptTextToMessageParts(
                scenario.scenarioId,
                normalized.messageParts,
                incoming.scriptText
            )
        }
        normalized.scriptText =
            normalized.scriptText ||
            getScriptTextFromMessageParts(scenario.scenarioId, normalized.messageParts)
    }
    if (scenario.scenarioId === 5) {
        normalized.phones = (normalized.phones || []).map(item => normalizeCommPhoneEntry(item))
    }
    return normalized
}

function buildScriptSettings(scenario, fallback = {}) {
    const messageParts = normalizeScriptMessageParts(scenario.settings.messageParts)
    return {
        scriptText:
            scenario.settings.scriptText ||
            getScriptTextFromMessageParts(scenario.scenarioId, messageParts),
        messageParts,
        ...fallback,
    }
}

export function buildLaunchSettings(scenarios) {
    const settingsByScenarioId = {}
    const scenariosWithSettings = new Set([1, 2, 5, 6, 7, 8, 9, 10, 12, 14, 15])

    scenarios.forEach(scenario => {
        if (!scenariosWithSettings.has(scenario.scenarioId)) {
            return
        }

        if (scenario.scenarioId === 1) {
            settingsByScenarioId[1] = { mode: scenario.settings.mode || 'test' }
            return
        }

        if (scenario.scenarioId === 2) {
            settingsByScenarioId[2] = {
                contacts: (scenario.settings.contacts || [])
                    .filter(contact => String(contact?.phone ?? contact?.contactValue ?? '').trim())
                    .map(contact => ({
                        phone: String(contact.phone ?? contact.contactValue ?? '').trim(),
                        isVerified: contact.isVerified ?? undefined,
                        displayName: contact.displayName ?? undefined,
                    })),
                sendToReportRecipients: Boolean(scenario.settings.sendToReportRecipients),
            }
            return
        }

        if (scenario.scenarioId === 5) {
            settingsByScenarioId[5] = {
                phones: (scenario.settings.phones || [])
                    .map(item => normalizeCommPhoneEntry(item).phone)
                    .filter(Boolean),
            }
            return
        }

        if (scenario.scenarioId === 6) {
            settingsByScenarioId[6] = buildScriptSettings(scenario, {
                visitsFrom: scenario.settings.visitsFrom ?? 1,
                visitsTo: scenario.settings.visitsTo ?? 1,
                daysFrom: scenario.settings.daysFrom ?? 25,
                daysTo: scenario.settings.daysTo ?? 30,
            })
            return
        }

        if (scenario.scenarioId === 7) {
            settingsByScenarioId[7] = buildScriptSettings(scenario)
            return
        }

        if (scenario.scenarioId === 8) {
            settingsByScenarioId[8] = buildScriptSettings(scenario)
            return
        }

        if (scenario.scenarioId === 9) {
            settingsByScenarioId[9] = buildScriptSettings(scenario, {
                visitsFrom: scenario.settings.visitsFrom ?? 3,
                visitsTo: scenario.settings.visitsTo ?? 1000,
                masterIds: scenario.settings.masterIds || [],
            })
            return
        }

        // Условия «отменил запись 2-7 дней назад» заданы в шаблонной активации и
        // не редактируются из стартерпака, поэтому отправляем только скрипт.
        if (scenario.scenarioId === 10) {
            settingsByScenarioId[10] = buildScriptSettings(scenario)
            return
        }

        if (scenario.scenarioId === 12) {
            settingsByScenarioId[12] = {
                enabled: scenario.settings.enabled ?? true,
                scriptText: scenario.settings.scriptText || '',
                additionalServiceIds: scenario.settings.additionalServiceIds || [],
            }
            return
        }

        if (scenario.scenarioId === 14) {
            settingsByScenarioId[14] = buildScriptSettings(scenario, {
                daysFrom: scenario.settings.daysFrom ?? 14,
                daysTo: scenario.settings.daysTo ?? 60,
            })
            return
        }

        if (scenario.scenarioId === 15) {
            settingsByScenarioId[15] = buildScriptSettings(scenario, {
                daysFrom: scenario.settings.daysFrom ?? 61,
                daysTo: scenario.settings.daysTo ?? 120,
            })
        }
    })

    return settingsByScenarioId
}
